// extracted by mini-css-extract-plugin
export default {"hr":"Divider_hr__1+3qV"};